<template>
  <b-form-group
    :label="label"
    :label-for="name"
    :description="helptext"
    class="radio-select"
  >
    <b-form-radio-group :id="name" buttons button-variant="outline-success" @change="change" :options="options" v-model="state" name="radio-btn-outline">
    </b-form-radio-group>
    <div v-if="formHandle.$error">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>
export default {
  data: () => {
    return {
      state: ''
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    model: {
      default: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helptext: {
      type: String
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  methods: {
    change () {
      this.$emit('updateModel', this.state)
      this.$emit('change')
    }
  },
  watch: {
    'state': function () {
      this.change()
    },
    'model': function () {
      this.state = this.model
    }
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>

<style>
.radio-select {
  position: relative;
  z-index: 0;
}
.radio-group {
  display: flex;
  align-items: center;
}
.radio-group > div {
  display: flex;
  align-items: center;
  margin: 0 10px;
  cursor: pointer;
}
.radio-group > div:first-child {
  margin-left: 0
}
.radio-group > div:last-child {
  margin-right: 0
}
.radio-group > div label {
  margin-left: 3px;
  margin-bottom: 0;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/custom/PRadio.vue